import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(
  {
    content: {
      alignItems: "center",
      display: "inline-flex",
      paddingBottom: "0 !important",
      paddingTop: "0 !important"
    },
    icon: {
      height: "20px",
      margintRight: 5
    },
    lineOne: {
      color: "#FFFFFF",
      paddingBottom: 0,
      paddingTop: 0,
      textAlign: "center"
    },
    root: {
      "&:before": {
        backgroundColor: "#EC5D77",
        bottom: -7,
        content: "' '",
        height: 20,
        position: "absolute",
        right: 80,
        transform: "rotate(45deg)",
        width: 20
      },
      backgroundColor: "#EC5D77",
      border: "1px solid #EC5D77",
      color: "#ec5e77",
      display: "inline-block",
      fontSize: "13px",
      height: "auto",
      marginBottom: 0,
      paddingBottom: 1,
      paddingTop: 5,
      position: "relative",
      whiteSpace: "normal",
      width: "175px"
    }
  },
  { name: "FailedStatusOrderTooltip" }
);

export interface FailedStatusOrderTooltipProps {
  message: string;
  visible?: boolean;
}

const FailedStatusOrderTooltip: React.SFC<FailedStatusOrderTooltipProps> = props => {
  const classes = useStyles(props);

  const { message, visible = false } = props;

  if (!visible) {
    return <></>;
  }

  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <div
          style={{
            paddingBottom: "0",
            zIndex: 1
          }}
        >
          <div className={classes.lineOne}>
            {" "}
            <span>{message}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default FailedStatusOrderTooltip;
